module.exports = __webpack_public_path__ + "img/Den_Norske_Dictionarium_Gravstein.a1280dbb.jpg";